const ticket_contacts = {
  email: 'Courriel du contact',
  first_name: 'Prénom du contact',
  last_name: 'Nom du contact',
  phone_mobile: 'Téléphone du contact',
};

export default ticket_contacts;
